import { invoke } from 'lodash';

const localhostRegExps = [
  /^localhost$/,
  /^\[::1\]$/,
  /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
];

const { hostname } = window.location;
const isLocalhost = localhostRegExps.some(regexp => hostname.match(regexp));

export function register(callbacks) {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator))
    return;

  const publicUrl = new URL(process.env.PUBLIC_URL, window.location);
  if (publicUrl.origin !== window.location.origin) {
    // Our service worker won't work if PUBLIC_URL is on a different origin
    // from what our page is served on. This might happen if a CDN is used to
    // serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
    return;
  }

  window.addEventListener('load', () => {
    const serviceWorkerUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    if (isLocalhost) checkValidServiceWorker(serviceWorkerUrl, callbacks);
    else registerValidServiceWorker(serviceWorkerUrl, callbacks);
  });
}

const registerValidServiceWorker = async (serviceWorkerUrl, callbacks) => {
  function onupdatefound() {
    const installingWorker = this.installing;

    installingWorker.onstatechange = () => {
      if (installingWorker.state !== 'installed') return;

      const isUpdate = !!navigator.serviceWorker.controller;
      console.log(
        isUpdate
          ? 'App update is available; refresh page'
          : 'App is now available for offline use',
      );
      invoke(callbacks, isUpdate ? 'onupdateinstalled' : 'oninstalled');
    };
  }

  try {
    const registration = await navigator.serviceWorker.register(
      serviceWorkerUrl,
    );
    registration.onupdatefound = onupdatefound;
  } catch (error) {
    console.error('Error during service worker registration:', error);
    invoke(callbacks, 'onerror', error);
    return;
  }
};

const checkValidServiceWorker = async (serviceWorkerUrl, callbacks) => {
  let response;
  try {
    response = await fetch(serviceWorkerUrl);
  } catch (error) {
    console.warn('App is running in offline mode');
    invoke(callbacks, 'onoffline');
    return;
  }

  const { status, headers } = response;
  const contentType = headers.get('content-type');
  if (status === 404 || contentType.indexOf('javascript') === -1) {
    // No service worker found. Probably a different app. Reload the page.
    const registration = await navigator.serviceWorker.ready;
    await registration.unregister();
    window.location.reload();
    return;
  }

  return registerValidServiceWorker(serviceWorkerUrl, callbacks);
};

export const unregister = async () => {
  if (!('serviceWorker' in navigator)) return;

  const registration = await navigator.serviceWorker.ready;
  await registration.unregister();
};



// WEBPACK FOOTER //
// ./src/serviceWorker.js